module.exports = {"441204001":"南岸街道","441204100":"河台镇","441204101":"乐城镇","441204102":"水南镇","441204103":"禄步镇","441204105":"小湘镇","441204106":"大湾镇","441204107":"新桥镇","441204108":"白诸镇","441204109":"莲塘镇","441204110":"活道镇","441204111":"蛟塘镇","441204112":"回龙镇","441204113":"白土镇","441204114":"金渡镇","441204115":"金利镇","441204116":"蚬岗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441204.json
// module id = 2013
// module chunks = 0